import React from 'react';
import axios from 'axios';
import swal from 'sweetalert';
import {withFormik} from 'formik';
import {object, string, number} from 'yup';
import Button from "@material-ui/core/Button";

import i18n from '../../i18n';
import {mergeWithDefault} from "../Form/utils";
import FormField from '../Form/FormField';
// import FormNumber from '../Form/FormNumber';

const InnerForm = ({
   values,
   errors,
   touched,
   handleChange,
   handleBlur,
   handleSubmit,
   isSubmitting,
   cancelUrl
}) => (
    <form onSubmit={handleSubmit}>
        <FormField
            label={i18n.get('life_cycle.form.name')}
            type="text"
            name="name"
            error={errors.name}
            touched={touched.name}
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.name}
        />

        <FormField
            label={i18n.get('life_cycle.form.rate')+' (%)'}
            type="text"
            name="rate"
            error={errors.rate}
            touched={touched.rate}
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.rate ? values.rate.toString().replace('.', ',') : 0}
        />

        <Button
            disabled={isSubmitting}
            variant="contained"
            color="primary"
            type="submit"
        >
            {i18n.get('life_cycle.submit')}
        </Button>
    </form>
);

const LifeCycleRateForm = withFormik({
    mapPropsToValues: props => {
        return mergeWithDefault(props.values, {
            name: '',
            rate: '0',
        });
    },
    validationSchema: object().shape({
        name: string()
            .required(i18n.get('validation.required', {attribute: i18n.get('life_cycle.form.name')})),
        rate: number()
            .required(i18n.get('validation.required', {attribute: i18n.get('life_cycle.form.rate')}))
            .typeError(i18n.get('validation.numeric', {attribute: i18n.get('life_cycle.form.rate')})),

    }),
    handleSubmit: (values,
                   {
                       props,
                       setSubmitting,
                       setErrors,
                   }) => {
        setSubmitting(true);

        axios({
            method: props.method,
            url: props.url,
            data: values,
        })
            .then(response => {
                setSubmitting(false);
                let data = response.data;


                // Show success message.
                return swal({
                    text: i18n.get('life_cycle.saved.success'),
                    icon: "success",
                }).then(() => {
                    if (data.forward) {
                        window.location.href = data.forward;
                    }
                });
            })
            .catch(error => {
                setSubmitting(false);

                if (error.response && error.response.data && error.response.data.errors) {
                    setErrors(error.response.data.errors);
                }

                // Show error message.
                return swal({
                    text: i18n.get('life_cycle.saved.error'),
                    icon: "error",
                });
            });
    },
})(InnerForm);

export default LifeCycleRateForm;